import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { 
  Typography, 
  Box, 
  Button,
  Paper
} from '@mui/material';
import { Home as HomeIcon, BugReport as BugIcon, Refresh as RefreshIcon } from '@mui/icons-material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error for debugging
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Paper 
          elevation={0}
          sx={{ 
            p: 6,
            borderRadius: 5,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            minHeight: '400px',
            boxShadow: '0 30px 60px rgba(0,0,0,0.15)',
            border: '1px solid rgba(255, 255, 255, 0.3)'
          }}
        >
          <BugIcon 
            sx={{ 
              fontSize: '4rem', 
              color: '#ff6b6b', 
              mb: 2,
              opacity: 0.8
            }} 
          />
          
          <Typography 
            variant="h4" 
            sx={{ 
              color: 'rgba(0, 0, 0, 0.8)',
              fontWeight: 600,
              fontSize: { xs: '1.5rem', sm: '2rem' },
              mb: 1
            }}
          >
            Něco se pokazilo
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{ 
              color: 'rgba(0, 0, 0, 0.6)',
              fontSize: '1.1rem',
              mb: 4,
              maxWidth: '400px'
            }}
          >
            Omlouváme se, došlo k neočekávané chybě. Zkuste stránku obnovit nebo se vraťte na hlavní stránku.
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button
              onClick={() => window.location.reload()}
              variant="outlined"
              startIcon={<RefreshIcon />}
              sx={{
                borderRadius: 50,
                px: 3,
                py: 1.5,
                fontWeight: 'bold',
                textTransform: 'none',
                borderColor: '#ff6b6b',
                color: '#ff6b6b',
                '&:hover': {
                  backgroundColor: 'rgba(255, 107, 107, 0.1)',
                  borderColor: '#ff6b6b',
                }
              }}
            >
              Obnovit stránku
            </Button>
            
            <Button
              component={RouterLink}
              to="/"
              variant="contained"
              startIcon={<HomeIcon />}
              sx={{
                borderRadius: 50,
                px: 3,
                py: 1.5,
                fontWeight: 'bold',
                textTransform: 'none',
                background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
                boxShadow: '0 4px 15px rgba(255, 107, 107, 0.3)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #ff5252 0%, #e53e3e 100%)',
                  boxShadow: '0 6px 20px rgba(255, 107, 107, 0.4)',
                  transform: 'translateY(-1px)',
                }
              }}
            >
              Hlavní stránka
            </Button>
          </Box>
        </Paper>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 